RivalIQ.apps.Admin.apps.Query.module('views', function (views, App, Backbone, Marionette, $, _, async) {

    'use strict';

    views.Queries = Marionette.LayoutView.extend({

        template: '#adminQueryQueriesTemplate',

        ui: {
            select: '.x-queries',
            createBtn: '.x-create'
        },

        events: {
            'change @ui.select': 'onQuerySelect',
            'click @ui.createBtn': 'create'
        },

        onAttach: function () {
            const me = this;

            const options = _.map(me.collection.toJSON(), function (item) {
                return {
                    id: item.id,
                    name: item.displayName
                };
            });

            let value;
            me.ui.select.selectize({
                selectOnTab: true,
                preload: true,
                openOnFocus: false,
                labelField: 'name',
                searchField: 'name',
                valueField: 'id',
                noEmptySelection: true,
                options: options,
                wrapperClass: 'riq-select',
                inputClass: 'riq-select-input',
                dropdownClass: 'riq-select-dropdown',
                dropdownContentClass: 'riq-select-dropdown-content',
                onDropdownOpen: function (dropdown) {
                    const selectize = me.ui.select[0].selectize;
                    value = selectize.getValue();
                    selectize.clear(true);
                },
                onDropdownClose: function () {
                    const selectize = me.ui.select[0].selectize;
                    const currentValue = selectize.getValue();
                    if (!currentValue) {
                        selectize.setValue(value, true);
                    }
                }
            });

            const selectize = me.ui.select[0].selectize;
            selectize.focus();
        },

        onQuerySelect: function () {
            const me = this;

            const queryId = me.ui.select.val();
            me.loadQuery(queryId);
        },

        loadQuery: function (queryId) {
            window.location = `#/queries/${queryId}`;
        },

        create: function () {
            const me = this;

            const model = new RivalIQ.apps.Admin.models.Query({
                name: App.defaultQueryName,
                query: App.defaultQueryText
            });
            model.save().done(function () {
                const queryId = model.get('id');
                me.loadQuery(queryId);
            }).fail(function () {
                RivalIQ.apps.Admin.queryTab.showError();
            });

        }

    });

}, RivalIQ.utils.async);
